import Vue from 'vue'
import AppAutosizeTextarea from '../../../components/AppAutosizeTextarea'
import AppDatetimePicker from '../../../components/AppDateTimePicker'
import AppTimePicker from '../../../components/AppTimePicker'

import WysiwygMixin from '../wysiwyg_mixin'
import ModalMixin from '../modal_mixin'

// TODO: 無駄が多いので整理したい
import { DatePicker, TimePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'
import ElementUIHelper from '../../../element-ui-helper'
import Swal from 'sweetalert2'
import axios from 'axios'

locale.use(lang)

Vue.component("app-autoresize-textarea", AppAutosizeTextarea)
Vue.component("app-datetime-picker", AppDatetimePicker)
Vue.component("app-time-picker", AppTimePicker)

export default (data) => {
    // data.disabled = data.mode === 'show'
    // data.pickerOptions = ElementUIHelper.DatePickerOptions({ btnToday: true })

    // Summernote用の設定
    data.uploadImageUrl = '/admin/news/upload_img'
    data.uploadFileUrl = '/admin/news/upload_img'
    data.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
    data.errors = data.errors || {}
    // WYSIWYGミックスイン用の初期値
    data.wysiwygSelectedFileName = data.wysiwygSelectedFileName || null

    const vm = new Vue({
        el: '#news-content',
        mixins: [WysiwygMixin, ModalMixin],
        data() {
            return data;
        },
        mounted() {
            // Summernoteを初期化
            this.initSummernote('#wysiwyg_editor', {
                styleTags: ['p', 'h3', 'h4', 'h5'],
                styleLabels: {
                    p: '標準',
                    h3: 'ヘッダー3',
                    h4: 'ヘッダー4',
                    h5: 'ヘッダー5',
                }
            })
        },
        watch: {
            editor(newVal) {
                // エディタが初期化されたら、editModeがfalseの場合は無効化
                if (newVal && !this.editMode) {
                    this.$nextTick(() => {
                        newVal.summernote('disable');
                    });
                }
            }
        },
        methods:{
            updateComment(contents) {
                // WYSIWYGエディタの内容をVueモデルに反映
                this.news.contents = contents
            },
            toggleEditMode(){
                this.editMode = !this.editMode
            },
            showAddCategoryModal(){
                let showAddCategoryModal = this.showAddCategoryModal
                Swal.fire({
                    title: '追加したいカテゴリー名を<br>入力してください',
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: '追加',
                    cancelButtonText: 'キャンセル',
                    showLoaderOnConfirm: true,
                    preConfirm: (catgory_name) => {
                        if (catgory_name==''){
                            Swal.fire({
                                icon: 'error',
                                title: 'カテゴリー名を<br>入力してください',
                            }).then(function(){
                                showAddCategoryModal()
                            })
                            return
                        }
                        if (catgory_name=='お知らせ'){
                            Swal.fire({
                                icon: 'error',
                                title: '既に登録済みのカテゴリー名です',
                            }).then(function(){
                                showAddCategoryModal()
                            })
                            return
                        }
                        return axios.post('/admin/news-categories/add', { catgory_name}).then(function(res){
                            return res.data
                        })
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(result.value.value == false){
                            Swal.fire({
                                icon: 'error',
                                title: '既に登録済みのカテゴリー名です',
                            }).then(function(){
                                showAddCategoryModal()
                            })
                        }else{
                            Swal.fire({
                                icon: 'success',
                                title: 'カテゴリーを追加しました',
                            })
                            this.category_options.push({text: result.value.text, value: result.value.value})
                            this.news.category_id = result.value.value
                        }
                    }
                })
            },
            saveContent() {
                // Summernoteのコンテンツをクリーンアップして保存
                if (this.editor) {
                    // Vueモデルとtextareaに反映
                    const cleanedContent = this.getCleanContent()
                    this.news.contents = cleanedContent
                    this.editor.summernote('code', cleanedContent)
                }
            }
        }
    })
}
